module.exports = __webpack_public_path__ + "img/loves.332ff386.webp";